import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicNominationPlanSettings({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M11.423 1.072a1 1 0 01.866.5L15.71 7.5a1 1 0 010 1l-3.422 5.928a1 1 0 01-.866.5H4.577a1 1 0 01-.866-.5L.29 8.5a1 1 0 010-1L3.71 1.572a1 1 0 01.866-.5h6.846zm-.289 1.499H4.867L1.732 8l3.135 5.428h6.267L14.269 8l-3.135-5.429zM8 5a3 3 0 110 6 3 3 0 010-6zm0 1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicNominationPlanSettings.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicNominationPlanSettings.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicNominationPlanSettings svgRef={ref} {...props} />
));
export default ForwardRef;
